import Immutable from 'immutable';

import reducerCreator from '../tools/reducer-creator';
import * as types from '../actions/list-settings/types';
import { AUTH_USER_RESET_DATA } from '../actions/auth-user/types';

const initialState = Immutable.fromJS({});

export default reducerCreator(initialState, {
  [types.LIST_SETTINGS_SET_DATA]: (state, { listName, settings }) =>
    state.set(listName, settings),

  [AUTH_USER_RESET_DATA]: () => initialState
});



// WEBPACK FOOTER //
// ./src/reducers/list-settings.js